import React from "react";
import { Facebook, Twitter, MessageCircle, Link2 } from "lucide-react";
import { copyText } from "./party/TvShare";

export function SocialShare({ url, text, id, onShare }) {
  const u = encodeURIComponent(url);
  const t = encodeURIComponent(text);
  const links = [
    ["facebook", "Facebook", Facebook, `https://www.facebook.com/sharer/sharer.php?u=${u}`],
    ["x", "X", Twitter, `https://twitter.com/intent/tweet?text=${t}&url=${u}`],
    ["whatsapp", "WhatsApp", MessageCircle, `https://wa.me/?text=${t}%20${u}`],
  ];
  const b = "flex items-center gap-1 text-[11px] px-2.5 py-1.5 rounded-full border border-[var(--line)] hover:border-[var(--gold)] transition-colors";
  return (
    <div className="flex flex-wrap gap-1.5 items-center">
      {links.map(([k, l, I, href]) => <a key={k} href={href} onClick={onShare} target="_blank" rel="noreferrer" className={b} data-testid={`social-${k}-${id}`}><I className="w-3 h-3" /> {l}</a>)}
      <button onClick={() => { onShare?.(); copyText(url, "Link copied"); }} className={b} data-testid={`social-copy-${id}`}><Link2 className="w-3 h-3" /> Copy link</button>
    </div>
  );
}
